<template>
  <ul class="navbar-nav bg-primary sidebar sidebar-dark accordion" id="accordionSidebar">
    <!-- Sidebar - Brand -->
    <a class="sidebar-brand d-flex align-items-center justify-content-center bg-light" href="javascript:void(0)">
      <div class="sidebar-brand-icon rotate-n-15">
        <i><img src="../../static/img/logo-1.png" alt="mycs" width="45"/></i>
      </div>
      <div class="h4 sidebar-brand-text mx-3" style="font-weight: bold">
        <span class="text-primary">M</span>
        <span class="text-warning">Y</span>
        <span class="text-primary">C</span>
        <span class="text-warning">S</span>
      </div>
    </a>
    <hr class="sidebar-divider">
    <!-- Nav Item - Dashboard -->
    <li class="nav-item" v-bind:class="{active: isDashboard}">
      <router-link class="nav-link" to="/dashboard" v-if="role==2">
        <i class="fas fa-fw fa-tachometer-alt"></i>
        <span v-if="language == 'fr'">Tableau de Bord</span>
        <span v-if="language == 'en'">Dashboard</span>
      </router-link>
      <router-link class="nav-link" to="/roles" v-if="role==2">
        <i class="fas fa-fw fa-key"></i>
        <span v-if="language == 'fr'">Roles</span>
        <span v-if="language == 'en'">Roles</span>
      </router-link>
      <router-link class="nav-link" to="/activities" v-if="role==2">
        <i class="fas fa-fw fa-tasks"></i>
        <span v-if="language == 'fr'">Activités</span>
        <span v-if="language == 'en'">Activities</span>
      </router-link>
      <router-link class="nav-link" to="/business" v-if="role==2">
        <i class="fas fa-fw fa-briefcase"></i>
        <span v-if="language == 'fr'">Business Units</span>
        <span v-if="language == 'en'">Business Units</span>
      </router-link>
      <router-link class="nav-link" to="/areas" v-if="role==2">
        <i class="fas fa-fw fa-globe"></i>
        <span v-if="language == 'fr'">Régions</span>
        <span v-if="language == 'en'">Areas</span>
      </router-link>
      <router-link class="nav-link" to="/countries" v-if="role==2">
        <i class="fas fa-fw fa-flag"></i>
        <span v-if="language == 'fr'">Pays</span>
        <span v-if="language == 'en'">Countries</span>
      </router-link>
      <router-link class="nav-link" to="/companies" v-if="role==2">
        <i class="fas fa-fw fa-building"></i>
        <span v-if="language == 'fr'">Entreprises</span>
        <span v-if="language == 'en'">Companies</span>
      </router-link>
      <router-link class="nav-link" to="/sites" v-if="role==2">
        <i class="fas fa-fw fa-store"></i>
        <span v-if="language == 'fr'">Sites</span>
        <span v-if="language == 'en'">Sites</span>
      </router-link>
      <router-link class="nav-link" to="/assessors" v-if="role==2">
        <i class="fas fa-fw fa-tasks"></i>
        <span v-if="language == 'fr'">Evaluateurs</span>
        <span v-if="language == 'en'">Assessors</span>
      </router-link>
      <router-link class="nav-link" to="/users" v-if="role==2">
        <i class="fas fa-fw fa-users"></i>
        <span v-if="language == 'fr'">Utilisateurs</span>
        <span v-if="language == 'en'">Users</span>
      </router-link>
      <router-link class="nav-link" to="/standards" v-if="role>=2">
        <i class="fas fa-fw fa-cogs"></i>
        <span v-if="language == 'fr'">Standards</span>
        <span v-if="language == 'en'">Standards</span>
      </router-link>
    </li>
    <hr class="sidebar-divider">
    <!-- Sidebar Toggler (Sidebar) -->
    <div class="text-center d-none d-md-inline">
      <button class="rounded-circle border-0" id="sidebarToggle"></button>
    </div>
  </ul>
  <!-- End of Sidebar -->
</template>

<script>
export default {
  data () {
    return {
      language: '',
      user: '',
      role: '',
      isDashboard: false,
      isSector: false,
      isContinent: false,
      isActivity: false,
      isCountry: false,
      isClient: false,
      isContract: false,
      isStandard: false,
      isSiteType: false,
      isSite: false,
      isOrganisation: false,
      isLanguage: false,
      isQuestionType: false,
      isAssessor: false,
      isMission: false,
      isRole: false,
      isUser: false,
      isAssessment: false,
    }
  },
  methods: {
    init () {
      (function ($) {
        'use strict'
        // Toggle the side navigation
        $('#sidebarToggle, #sidebarToggleTop').on('click', function (e) {
          $('body').toggleClass('sidebar-toggled')
          $('.sidebar').toggleClass('toggled')
          if ($('.sidebar').hasClass('toggled')) {
            $('.sidebar .collapse').collapse('hide')
          };
        })
        // Close any open menu accordions when window is resized below 768px
        $(window).resize(function () {
          if ($(window).width() < 768) {
            $('.sidebar .collapse').collapse('hide')
          }
        })
        // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
        $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function (e) {
          if ($(window).width() > 768) {
            var e0 = e.originalEvent
            var delta = e0.wheelDelta || -e0.detail
            this.scrollTop += (delta < 0 ? 1 : -1) * 30
            e.preventDefault()
          }
        })
        // Scroll to top button appear
        $(document).on('scroll', function () {
          var scrollDistance = $(this).scrollTop()
          if (scrollDistance > 100) {
            $('.scroll-to-top').fadeIn()
          } else {
            $('.scroll-to-top').fadeOut()
          }
        })
        // Smooth scrolling using jQuery easing
        $(document).on('click', 'a.scroll-to-top', function (e) {
          var $anchor = $(this)
          $('html, body').stop().animate({
            scrollTop: ($($anchor.attr('href')).offset().top)
          }, 1000, 'easeInOutExpo')
          e.preventDefault()
        })
      })(jQuery)
    }
  },
  mounted () {
    this.language = localStorage.getItem('std_language')
    var user = JSON.parse(localStorage.getItem('std_user'))
    this.role = user.role_id
    this.init()
    switch (this.$route.name) {
      case 'Home':
        this.isDashboard = true
        break
      case 'Sectors':
        this.isSector = true
        break
      case 'Continents':
        this.isContinent = true
        break
      case 'Activities':
        this.isActivity = true
        break
      case 'Countries':
        this.isCountry = true
        break
      case 'Clients':
        this.isClient = true
        break
      case 'Contracts':
        this.isContract = true
        break
      case 'Standards':
        this.isStandard = true
        break
      case 'SiteTypes':
        this.isSiteType = true
        break
      case 'Sites':
        this.isSite = true
        break
      case 'Organisations':
        this.isOrganisation = true
        break
      case 'Languages':
        this.isLanguage = true
        break
      case 'QuestionTypes':
        this.isQuestionType = true
        break
      case 'Assessors':
        this.isAssessor = true
        break
      case 'Missions':
        this.isMission = true
        break
      case 'Roles':
        this.isRole = true
        break
      case 'Users':
        this.isUser = true
        break
      case 'Assessments':
        this.isAssessment = true
        break
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue